import favouritesService from '../services/favouritesService';

// The heart button on product cards — same behaviour as the Search page:
// session-based favourites, login modal on 401 with the click remembered.
export default {
  data() {
    return {
      favouritesMap: {},
      poppingFavouriteUrl: null
    };
  },
  created() {
    this.loadFavourites();
    this.$root.$on('favourites-changed', this.loadFavourites);
  },
  beforeDestroy() {
    this.$root.$off('favourites-changed', this.loadFavourites);
  },
  methods: {
    getFavouriteUrl(product) {
      return favouritesService.getProductUrlFromProduct(product);
    },

    isFavourited(product) {
      const url = this.getFavouriteUrl(product);
      return !!(url && this.favouritesMap && this.favouritesMap[url]);
    },

    async loadFavourites() {
      try {
        const list = await favouritesService.listFavourites();
        const nextMap = {};
        for (const fav of list) {
          if (fav && fav.url) nextMap[fav.url] = true;
        }
        this.favouritesMap = nextMap;
      } catch (err) {
        if (err && err.response && err.response.status === 401) return;
        console.warn('Failed to load favourites', err);
      }
    },

    async toggleFavourite(product) {
      const url = this.getFavouriteUrl(product);
      if (!url) {
        this.$root.$emit('show-toast', { message: 'Unable to favourite: missing product URL.', type: 'error' });
        return;
      }

      const currentlyFav = !!this.favouritesMap[url];
      try {
        this.poppingFavouriteUrl = currentlyFav ? null : url;
        if (currentlyFav) {
          await favouritesService.removeFavourite(url);
          this.$delete(this.favouritesMap, url);
        } else {
          await favouritesService.addFavourite(url);
          this.$set(this.favouritesMap, url, true);
        }
        setTimeout(() => {
          if (this.poppingFavouriteUrl === url) this.poppingFavouriteUrl = null;
        }, 220);
      } catch (err) {
        if (err && err.response && err.response.status === 401) {
          if (!currentlyFav) favouritesService.setPendingFavourite(url);
          this.$root.$emit('open-login-modal');
          return;
        }
        this.$root.$emit('show-toast', {
          message: err?.response?.data?.error || err?.message || 'Failed to update favourite.',
          type: 'error'
        });
      }
    }
  }
};
